import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { forwardRef, type InputHTMLAttributes } from "react";
import { StyledInput } from "./styles";

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  /** Input label text. */
  label: string;
}

// eslint-disable-next-line react/display-name
export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => (
  <>
    <VisuallyHidden.Root>
      <label htmlFor={props.id}>{props.label}</label>
    </VisuallyHidden.Root>
    {/* @ts-expect-error: refs don't play nice with typescript */}
    <StyledInput ref={ref} {...props} />
  </>
));
